import Vue from 'vue';

export default {

  async fetchEquipmentStatuses({ commit }, pvId) {
    return Vue.axios.get(Vue.$url("vessel-equipment-status/statuses?pvId=" + pvId))
      .then((rsp) => commit("SET_EQUIPMENT_STATUS_STATUSES", rsp.data))
  },

  async fetchEquipmentStatusByDprId({ commit }, dprId) {
    return Vue.axios.get(Vue.$url("vessel-equipment-status/dpr?dprId=" + dprId))
      .then((rsp) => commit("SET_EQUIPMENT_STATUSES", rsp.data))
  },

}